(function () {
    'use strict';

    angular
        .module('app.legal')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
           {
               state: 'privacy',
               config: {
                   url: '/privacy',
                   templateUrl: 'app/legal/privacyPolicy.html?v=' + opsIncludeVersion,
                   title: 'Privacy Policy'
               }
           },
           {
               state: 'terms',
               config: {
                   url: '/terms',
                   templateUrl: 'app/legal/terms.html?v=' + opsIncludeVersion,
                   title: 'Terms'
               }
           }
            
        ];
    }
})();
